/*
 * Copyright (c) 2021, 2022 Tropyc Stoic (38c316a1b8d7188d059c273d892b723b)
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */
import { useOutletContext, useParams } from "react-router-dom";
import ConfigureToken from '../ConfigureToken.js';

export default function Metadata() {
  const [web3,,, myTokens,, selectedTokenIndex] = useOutletContext();
  const { tokenAddress } = useParams(); // specific token in the URL

  var targetToken;

  if (tokenAddress)
    targetToken = tokenAddress;
  else if (myTokens && selectedTokenIndex && myTokens[selectedTokenIndex - 1])
    targetToken = myTokens[selectedTokenIndex - 1].address;

  return (
    <>
        <h2>Configure your token</h2>

        <p className="lead">
        In order to confirm contact coordinates and other token metadata, you can <b>optionally</b> save this in the contract itself!
        <br/>
        Note that adding it will not automatically propagate the info to public token trackers or other sites (though in the future, it may).
        </p>
        {
        !targetToken &&
          <p className="lead rounded border m-1 p-3">
            <button className="btn btn-secondary btn-lg" href="#" disabled>Configure</button> <small>(No tokens detected).</small>
          </p>
        }
        {targetToken &&
                <ConfigureToken web3={web3} myToken={targetToken} />
        }
    </>
  );
}